const initScrollToTop = () => {


    const scrollBtn = document.getElementById("scroll-to-top");

    if(!scrollBtn){
        return;
    }

    window.addEventListener("scroll", () => {
        if (window.scrollY > 200) {
            scrollBtn.classList.add("visible");
        } else {
            scrollBtn.classList.remove("visible");
        }
    });

    scrollBtn.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

}
export default initScrollToTop;